import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CodeValue from '~/components/patterns/values/CodeValue';
import Ellipsis from '~/components/patterns/values/Ellipsis';
import SmallTable from '~/components/atoms/issues/components/detailsPlaceholders/SmallTable';



const ELLIPSIS_POPUP_ZINDEX = 2000;



const messages = defineMessages({
	element: {
		id: 'ui.schemaOrgErrors.element',
	},
	path: {
		id: 'ui.schemaOrgErrors.path',
	},
	error: {
		id: 'ui.schemaOrgErrors.error',
	},
});



type Props = {
	issueContext: {
		errors: ReadonlyArray<{
			element: number,
			message: string,
			path: string,
		}>,
	},
	tableWidth: number,
};

const SchemaOrgErrorsTable: React.FC<Props> = (props) => {
	const {
		issueContext,
		tableWidth,
	} = props;

	const firstColumnWidth = Math.floor(tableWidth * (1 / 6.5));
	const secondColumnWidth = Math.floor(tableWidth * (1 / 2.5));

	return (
		<SmallTable
			columns={[
				{
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis popupZIndex={ELLIPSIS_POPUP_ZINDEX}>
									#{row.element + 1}
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.element} />,
					},
					width: firstColumnWidth,
				},
				{
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis>
									<CodeValue>
										{row.path}
									</CodeValue>
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.path} />,
					},
					width: secondColumnWidth,
				},
				{
					render: {
						cell: ({ row }) => {
							return (
								<Ellipsis popupZIndex={ELLIPSIS_POPUP_ZINDEX}>
									{row.message}
								</Ellipsis>
							);
						},
						header: () => <FormattedMessage {...messages.error} />,
					},
					width: 1000,
				},
			]}
			rows={issueContext.errors}
			tableWidth={tableWidth}
		/>
	);
};



export default React.memo(SchemaOrgErrorsTable);
